import { render, staticRenderFns } from "./PresentationByCategoryList.vue?vue&type=template&id=4c02b776&"
import script from "./PresentationByCategoryList.vue?vue&type=script&lang=js&"
export * from "./PresentationByCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports